import { useContext, useEffect, useState } from 'react';
import useSmartState from '../../../common/hooks/useSmartState';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getFuzzySearchCriteria, isEmpty } from '../../../library/Core/SmartFunctions';
import FactLoader from '../../../library/SimpleControls/FactLoader';
import ManageAlumniService from './ManageAlumniService';
import SearchCriteria from './SearchCriteria';

const Layout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const [showSearchCriteria, setShowSearchCriteria] = useState(true);
    const [userTypeCode, setUserTypeCode] = useState(sessionStorage.getItem('user-type-code'));
    const [isExpanded, setIsExpanded] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isActive = true;
        setLoading(true);

        ManageAlumniService.search(state.data.searchCriteria, state.routeInfo.pageName)
            .then((response: any) => {
                if (!isActive) return;
                setStateValue('alumniList', response.data);
            })
            .catch((error: any) => {
                console.error('Search API Error', error);
            })
            .finally(() => {
                if (isActive) setLoading(false);
            });

        return () => {
            isActive = false;
        };
    }, [state.data.searchCriteria]);


    const handleFuzzySearch = (event: any) => {
        event.preventDefault();
        // if (isEmpty(fuzzySearchText)) return;

         const currentSearchCriteria = state.data.searchCriteria;

        const mergedSearchCriteria = {
            ...currentSearchCriteria,
            ...getFuzzySearchCriteria(fuzzySearchText) 
        };

         ManageAlumniService.search(mergedSearchCriteria, state.routeInfo.pageName).then((response: any) =>
                setStateValue('alumniList', response.data)
        );
    };

    return (
        <div className="main flex-1">
            {/* <section className="updateadditionalinformation"> */}
                {/* <div className="container max-1140 px-lg-0 overflow-hidden"> */}
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="white-block white-block-notopborderradius p-0 h-100">
                                <div className="p-4 p-md-5">
                                    <div className="alumni_statistics">
                                        {/* <h2 className="font-26 font-600 mb-0 pb-4">{state.formConfig?.title}</h2> */}
                                        <h2 className="font-26 font-600 mb-0 pb-4">{userTypeCode == 'SUPER_ADMIN' ? "Student Profile Report" : state.formConfig?.title}</h2>

                                        <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                                            <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                                                <button className="btn-grpfiter me-3" type="button" onClick={() => setIsExpanded(!isExpanded)}>
                                                    <i className="icon-filter font-13 me-2"></i>
                                                    Filters
                                                </button>
                                                <div className="search alumniSearch m-0 open position-static flex-1">
                                                    {/* <div className="form-inline d-flex flex-wrap justify-content-between d-block"> */}
                                                    <form className="form-inline d-flex flex-wrap justify-content-between d-block" onSubmit={handleFuzzySearch}>
                                                        <input
                                                            value={fuzzySearchText}
                                                            placeholder={state.data.reportConfig.fuzzySearchPlaceholder}
                                                            aria-label="Search"
                                                            className="form-control flex-1 font-13 font-500 text-truncate"
                                                            onChange={(event) => setFuzzySearchText(event?.target.value)}
                                                        />
                                                        <button
                                                            className="btn btn-search icon icon-search"></button>
                                                    {/* </div> */}
                                                    </form>
                                                    {/* <a href="" className="btn-search-toggle icon-search"></a> */}
                                                </div>
                                            </div>
                                        </div>
                                        {showSearchCriteria && <SearchCriteria />}
                                        <FactLoader show={loading} />
                                        {props.children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            // </section>
        // </div>
    );
};

export default Layout;
